import type { FC, PropsWithChildren } from "react";

import type { LayoutV2 } from "~/core";
import { MainFooterV2 } from "~/widgets/main-footer-v2";
import { MainHeaderV2 } from "~/widgets/main-header-v2";

export type MainLayoutProps = {
  data: LayoutV2;
};

/**
 *  Новый Layout для приложения (Footer + Header) заполняются из коллекции layout_v2
 *  может быть переназначен для определенной страницы
 */
export const MainLayoutV2: FC<PropsWithChildren<MainLayoutProps>> = ({
  children,
  data,
}) => {
  return (
    <main className="min-h-screen flex flex-col justify-between">
      <MainHeaderV2 data={data} />
      {children}
      <MainFooterV2 data={data} />
    </main>
  );
};
